import Vue from 'vue';
import VueRouter from 'vue-router';
import MapService from '@/views/MapService.vue';
import SubscribeProject from '@/views/subscribeProject.vue';
import SubscribePerson from '@/views/subscribePerson.vue';

Vue.use(VueRouter);

const routes = [
  // ========== 在线取号模块（放最前面测试）==========
  {
    path: '/queue',
    name: 'QueueBusiness',
    component: () => import('../views/queue/QueueBusiness.vue'),
    meta: { title: '在线取号' }
  },
  // ========== 远程勘验模块 ==========
  {
    path: '/rtc',
    name: 'RtcHome',
    component: () => import('../views/rtc/RtcHome.vue'),
    meta: { title: '远程勘验' }
  },
  {
    path: '/rtc/list',
    name: 'RtcList',
    component: () => import('../views/rtc/RtcList.vue'),
    meta: { title: '踏勘列表' }
  },
  {
    path: '/rtc/room',
    name: 'RtcRoom',
    component: () => import('../views/rtc/RtcRoom.vue'),
    meta: { title: '远程勘查' }
  },
  {
    path: '/rtc/guide',
    name: 'RtcGuide',
    component: () => import('../views/rtc/RtcGuide.vue'),
    meta: { title: '操作指引' }
  },
  {
    path: '/rtc/evaluate',
    name: 'RtcEvaluate',
    component: () => import('../views/rtc/RtcEvaluate.vue'),
    meta: { title: '评价' }
  },
  {
    path: '/rtc/login',
    name: 'RtcLogin',
    component: () => import('../views/rtc/RtcLogin.vue'),
    meta: { title: '用户登录' }
  },
  {
    path: '/rtc/user',
    name: 'RtcUser',
    component: () => import('../views/rtc/RtcUser.vue'),
    meta: { title: '个人中心' }
  },
  {
    path: '/rtc/userEdit',
    name: 'RtcUserEdit',
    component: () => import('../views/rtc/RtcUserEdit.vue'),
    meta: { title: '修改信息' }
  },
  {
    path: '/rtc/project',
    name: 'RtcProject',
    component: () => import('../views/rtc/RtcProject.vue'),
    meta: { title: '踏勘指南' }
  },
  {
    path: '/rtc/apply',
    name: 'RtcApply',
    component: () => import('../views/rtc/RtcApply.vue'),
    meta: { title: '申请勘验' }
  },
  {
    path: '/rtc/meeting',
    name: 'RtcMeeting',
    component: () => import('../views/rtc/RtcMeeting.vue'),
    meta: { title: '踏勘记录' }
  },
  {
    path: '/rtc/detail',
    name: 'RtcDetail',
    component: () => import('../views/rtc/RtcDetail.vue'),
    meta: { title: '踏勘详情' }
  },
  {
    path: '/rtc/projectList',
    name: 'RtcProjectList',
    component: () => import('../views/rtc/RtcProjectList.vue'),
    meta: { title: '勘验申请事项清单' }
  },
  {
    path: '/rtc/checkpoints',
    name: 'CheckPoints',
    component: () => import('../views/rtc/CheckPoints.vue'),
    meta: { title: '审查要点' }
  },
  {
    path: '/rtc/checkpoints-onsite',
    name: 'CheckPointsOnsite',
    component: () => import('../views/rtc/CheckPointsOnsite.vue'),
    meta: { title: '审查要点 - 现场勘验' }
  },
  // ========== 问卷调查模块 ==========
  {
    path: '/survey',
    name: 'SurveyList',
    component: () => import('../views/survey/SurveyList.vue'),
    meta: { title: '问卷调查' }
  },
  {
    path: '/survey/detail',
    name: 'SurveyDetail',
    component: () => import('../views/survey/SurveyDetail.vue'),
    meta: { title: '问卷详情' }
  },
  {
    path: '/survey/result',
    name: 'SurveyResult',
    component: () => import('../views/survey/SurveyResult.vue'),
    meta: { title: '提交结果' }
  },
  // ========== 政策咨询模块 ==========
  {
    path: '/policy',
    name: 'PolicyHome',
    component: () => import('../views/policy/PolicyHome.vue'),
    meta: { title: '政策咨询' }
  },
  {
    path: '/policy/list',
    name: 'PolicyList',
    component: () => import('../views/policy/PolicyList.vue'),
    meta: { title: '政策列表' }
  },
  {
    path: '/policy/myConsult',
    name: 'MyConsult',
    component: () => import('../views/policy/MyConsult.vue'),
    meta: { title: '我的咨询' }
  },
  // ========== 投诉建议模块 ==========
  {
    path: '/complain',
    name: 'ComplainHome',
    component: () => import('../views/complain/ComplainHome.vue'),
    meta: { title: '投诉建议' }
  },
  // ========== 智能问答模块 ==========
  {
    path: '/qa',
    name: 'QaHome',
    component: () => import('../views/qa/QaHome.vue'),
    meta: { title: '智能问答' }
  },
  // ========== 视频咨询模块 ==========
  {
    path: '/video-consult',
    name: 'VideoConsultHome',
    component: () => import('../views/videoConsult/VideoConsultHome.vue'),
    meta: { title: '视频咨询' }
  },
  {
    path: '/video-consult/detail',
    name: 'VideoConsultDetail',
    component: () => import('../views/videoConsult/VideoConsultDetail.vue'),
    meta: { title: '预约详情' }
  },
  {
    path: '/video-consult/my-reserve',
    name: 'VideoConsultMyReserve',
    component: () => import('../views/videoConsult/VideoConsultMyReserve.vue'),
    meta: { title: '我的预约' }
  },
  {
    path: '/video-consult/my-meeting',
    name: 'VideoConsultMyMeeting',
    component: () => import('../views/videoConsult/VideoConsultMyMeeting.vue'),
    meta: { title: '办理记录' }
  },
  {
    path: '/video-consult/meeting-detail',
    name: 'VideoConsultMeetingDetail',
    component: () => import('../views/videoConsult/VideoConsultMeetingDetail.vue'),
    meta: { title: '会议详情' }
  },
  {
    path: '/video-consult/work-order',
    name: 'VideoConsultWorkOrder',
    component: () => import('../views/videoConsult/VideoConsultWorkOrder.vue'),
    meta: { title: '工单转交' }
  },
  {
    path: '/video-consult/user-center',
    name: 'VideoConsultUserCenter',
    component: () => import('../views/videoConsult/VideoConsultUserCenter.vue'),
    meta: { title: '我的咨询' }
  },
  {
    path: '/video-consult/room',
    name: 'VideoConsultRoom',
    component: () => import('../views/videoConsult/VideoConsultRoom.vue'),
    meta: { title: '视频会议' }
  },
  {
    path: '/video-consult/evaluate',
    name: 'VideoConsultEvaluate',
    component: () => import('../views/videoConsult/VideoConsultEvaluate.vue'),
    meta: { title: '服务评价' }
  },
  // ========== 消息中心 ==========
  {
    path: '/message',
    name: 'MessageCenter',
    component: () => import('../views/MessageCenter.vue'),
    meta: { title: '消息中心' }
  },
  // ========== 搜索页面 ==========
  {
    path: '/search',
    name: 'SearchPage',
    component: () => import('../views/SearchPage.vue'),
    meta: { title: '搜索' }
  },
  // ========== 失物招领 ==========
  {
    path: '/lostFound',
    name: 'LostFoundList',
    component: () => import('../views/LostFoundList.vue'),
    meta: { title: '失物招领' }
  },
  // ========== 热门服务列表 ==========
  {
    path: '/hotService',
    name: 'HotServiceList',
    component: () => import('../views/HotServiceList.vue'),
    meta: { title: '热门服务' }
  },
  // ========== 通知公告列表 ==========
  {
    path: '/noticeList',
    name: 'NoticeList',
    component: () => import('../views/NoticeList.vue'),
    meta: { title: '通知公告' }
  },
  {
    path: '/noticeDetail',
    name: 'NoticeDetail',
    component: () => import('../views/NoticeDetail.vue'),
    meta: { title: '公告详情' }
  },
  {
    path: '/queue/info',
    name: 'QueueInfo',
    component: () => import('../views/queue/QueueInfo.vue'),
    meta: { title: '填写信息' }
  },
  {
    path: '/queue/success',
    name: 'QueueSuccess',
    component: () => import('../views/queue/QueueSuccess.vue'),
    meta: { title: '取号成功' }
  },
  {
    path: '/queue/record',
    name: 'QueueRecord',
    component: () => import('../views/queue/QueueRecord.vue'),
    meta: { title: '取号记录' }
  },
  // ========== 我的办件 ==========
  {
    path: '/myMatters',
    name: 'MyMatters',
    component: () => import('../views/MyMatters.vue'),
    meta: { title: '我的办件' }
  },
  // ========== 我的二维码 ==========
  {
    path: '/myQrcode',
    name: 'MyQrcode',
    component: () => import('../views/MyQrcode.vue'),
    meta: { title: '我的二维码' }
  },
  // ========== 我的好差评 ==========
  {
    path: '/myEvaluation',
    name: 'MyEvaluation',
    component: () => import('../views/MyEvaluation.vue'),
    meta: { title: '我的好差评' }
  },
  // ========== 我的投诉建议 ==========
  {
    path: '/myComplaintSuggestion',
    name: 'MyComplaintSuggestion',
    component: () => import('../views/MyComplaintSuggestion.vue'),
    meta: { title: '我的投诉建议' }
  },
  // ========== 历史填报 ==========
  {
    path: '/historyForm',
    name: 'HistoryForm',
    component: () => import('../views/HistoryForm.vue'),
    meta: { title: '历史填报' }
  },
  // ========== 主首页 ==========
  {
    path: '/',
    name: 'MainHome',
    component: () => import('../views/MainHome.vue'),
    meta: { title: '首页' }
  },
  // ========== 地图服务模块 ==========
  {
    path: '/map',
    name: 'MapService',
    component: MapService,
    meta: { title: '地图服务' }
  },
  {
    path: '/map/detail',
    name: 'MapDetail',
    component: () => import('../views/map/MapDetail.vue'),
    meta: { title: '网点详情' }
  },
  // ========== 原有路由 ==========
  {
    path: '/old-home',
    name: 'OldHomePage',
    component: MapService,
  },
  {
    path: '/subscribeProject',
    name: 'subscribeProject',
    component: SubscribeProject,
  },
  {
    path: '/subscribeTime',
    name: 'subscribeTime',
    component: () => import('../views/SubscribleTime.vue'),
  },
  {
    path: '/subscribePerson',
    name: 'subscribePerson',
    component: SubscribePerson,
  },
  {
    path: '/queryCase',
    name: 'queryCase',
    component: () => import('../views/QueryCase.vue'),
  },
  {
    path: '/item-category',
    name: 'ItemCategory',
    component: () => import('../views/ItemCategory.vue'),
    meta: { title: '事项分类' }
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/Success.vue'),
  },
  {
    path: '/queryCaseDetail',
    name: 'queryCaseDetail',
    component: () => import('../views/QueryCaseDetail.vue'),
  },
  {
    path: '/cloudForm',
    name: 'CloudFormList',
    component: () => import('../views/CloudFormList.vue'),
    meta: { title: '云填单' }
  },
  {
    path: '/formEdit',
    name: 'FormEdit',
    component: () => import('../views/FormEdit.vue'),
    meta: { title: '表单编辑' }
  },
  {
    path: '/cloudDoc',
    name: 'CloudDocList',
    component: () => import('../views/CloudDocList.vue'),
    meta: { title: '云文档' }
  },
  {
    path: '/guideList',
    name: 'GuideList',
    component: () => import('../views/GuideList.vue'),
  },
  {
    path: '/guideDetail',
    name: 'GuideDetail',
    component: () => import('../views/GuideDetail.vue')
  },
  {
    path: '/reply',
    name: 'Reply',
    component: () => import('../views/Reply.vue')
  },
  {
    path: '/reserveList',
    name: 'ReserveList',
    component: () => import('../views/ReserveList.vue')
  },
  {
    path: '/reserveDetail',
    name: 'ReserveDetail',
    component: () => import('../views/ReserveDetail.vue')
  },
  {
    path: '/agreetment',
    name: 'Agreetment',
    component: () => import('../views/Agreetment.vue')
  },
  {
    path: '/feedbackList',
    name: 'FeedbackList',
    component: () => import('../views/FeedbackList.vue')
  },
  {
    path: '/favourList',
    name: 'FavourList',
    component: () => import('../views/FavourList.vue')
  },
  {
    path: '/feedbackDetail',
    name: 'FeedbackDetail',
    component: () => import('../views/FeedbackDetail.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue'),
    meta: { title: '忘记密码' }
  },
  {
    path: '/user',
    name: 'UserCenter',
    component: () => import('../views/UserCenter.vue')
  },
  {
    path: '/editUserInfo',
    name: 'EditUserInfo',
    component: () => import('../views/EditUserInfo.vue'),
    meta: { title: '修改个人信息' }
  },
  {
    path: '/siteDetail',
    name: 'SiteDetail',
    component: () => import('../views/SiteDetail.vue')
  }
];

const router = new VueRouter({
  routes,
});

export default router;

